/**
 * Los dibujos que se transforman unos en otros por el portal.
 *
 * Están escritos aquí y no traídos de un set de iconos a propósito.
 * `morphicons` solo sabe interpolar iconos de trazo, y el portal usa los de
 * MUI, que son de relleno: meter Lucide habría dejado dos lenguajes de iconos
 * conviviendo en la misma fila. Dibujados a medida, todos comparten lienzo de
 * 24×24, grosor y remates redondos, así que se sientan al lado de un icono de
 * MUI sin cantar.
 *
 * Compartir lienzo no es un detalle: es lo que permite que el motor resuelva
 * la rotación entre dos formas en vez de leer la diferencia de escala como si
 * lo fuera.
 */
export const TRAZOS = {
  asistenteCarga: "M5 5h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-8l-5 4v-4H5a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z M8 10h8 M8 14h5",
  cerebroCarga: "M12 5a3 3 0 1 0-6 0 4 4 0 0 0-2 7 4 4 0 0 0 2 7 3 3 0 0 0 6 0V5Z M12 5a3 3 0 1 1 6 0 4 4 0 0 1 2 7 4 4 0 0 1-2 7 3 3 0 0 1-6 0 M8 9l4 3 4-3 M8 16l4-4 4 4",
  comercialCarga: "M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8Z M4 21v-2a8 6 0 0 1 16 0v2 M10 14l2 3 2-3 M12 17v4",
  /** Edición de una lectura: lápiz en reposo y escribiendo. */
  editarLectura: "M4 20l4-1 12-12-3-3L5 16l-1 4Z M14 7l3 3",
  confirmarLectura: "M5 12l4 4L19 6 M5 12l4 4L19 6",
  confirmarLecturaDoble: "M2 12l4 4L16 6 M8 12l4 4L22 6",
  editarEscribiendo: "M4 18l4-.5L21 8l-2.5-3L5 14.5 4 18Z M16 7l2.5 3 M4 21h12",
  /** Contraseña oculta ↔ visible. */
  ojo: "M2 12s3.6-7 10-7 10 7 10 7-3.6 7-10 7-10-7-10-7Z M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z",
  ojoTachado:
    "M10.7 5.1A9.9 9.9 0 0 1 12 5c6.4 0 10 7 10 7a13.2 13.2 0 0 1-1.7 2.4 M6.6 6.6A13.5 13.5 0 0 0 2 12s3.6 7 10 7a9.9 9.9 0 0 0 4.4-1.1 M9.9 9.9a3 3 0 0 0 4.2 4.2 M2 2l20 20",

  /** Enviar ↔ detener, en el compositor del chat. */
  enviar: "M22 2 11 13 M22 2 15 22l-4-9-9-4 20-7Z",
  parar:
    "M7 5h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2Z",

  /** Copiar ↔ copiado. */
  copiar:
    "M9 9h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V11a2 2 0 0 1 2-2Z M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1",
  visto: "M20 6 9 17l-5-5",

  /** Menú plegado ↔ desplegado. */
  menu: "M4 6h16 M4 12h16 M4 18h16",
  flechaIzquierda: "M15 18l-6-6 6-6",

  /** Desplegar ↔ plegar. */
  flechaAbajo: "M6 9l6 6 6-6",
  flechaArriba: "M18 15l-6-6-6 6",

  /** Panel móvil de notificaciones: campana ↔ cerrar. */
  campana: "M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9 M10 21h4",
  cerrar: "M6 6l12 12 M18 6 6 18",

  /** Acciones del historial de notificaciones. */
  marcarLeidas: "M2 12l4 4L14 8 M10 16l4 4 8-8",
  papelera: "M4 7h16 M9 7V4h6v3 M6 7l1 14h10l1-14 M10 11v6 M14 11v6",
  ajustes:
    "M4 6h10 M18 6h2 M14 4v4 M4 12h2 M10 12h10 M6 10v4 M4 18h8 M16 18h4 M12 16v4",

  /** Pasos del alta de una solicitud. */
  pasoDatos:
    "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z M7 8h10 M7 12h10 M7 16h6",
  pasoDocumentos:
    "M6 2h9l5 5v15H6a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z M15 2v5h5 M8 12h8 M8 16h6",
  pasoProcesando:
    "M20 7v5h-5 M4 17v-5h5 M6.1 8A7 7 0 0 1 18 6l2 1 M17.9 16A7 7 0 0 1 6 18l-2-1",
  pasoRevision:
    "M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Z M16 16l5 5 M7.5 10.5l2 2 4-4",
  pasoRecomendaciones:
    "M12 2l1.5 5.5L19 9l-5.5 1.5L12 16l-1.5-5.5L5 9l5.5-1.5L12 2Z M19 15l.8 2.2L22 18l-2.2.8L19 22l-.8-2.2L16 18l2.2-.8L19 15Z",
  pasoConfirmacion: "M20 6 9 17l-5-5 M12 2a10 10 0 1 1-8.2 4.3",
  pasoEnviado:
    "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2Z M7 12l3 3 7-7",

  /**
   * Reconocimiento de documentos dirigido por Atlas.
   *
   * No forman una animación con reloj propio: la pantalla cambia de trazo
   * únicamente cuando el `stage_code` publicado por Atlas cambia. Así el
   * dibujo cuenta la misma fase que el texto y el porcentaje, sin inventar
   * actividad local.
   */
  reconocimientoDocumento:
    "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z M15 2v5h5 M8 12h8 M8 16h5",
  reconocimientoEscaneo:
    "M3 7V5a2 2 0 0 1 2-2h2 M17 3h2a2 2 0 0 1 2 2v2 M21 17v2a2 2 0 0 1-2 2h-2 M7 21H5a2 2 0 0 1-2-2v-2 M7 8h10 M7 12h10 M7 16h7",
  reconocimientoCatalogo:
    "M4 4h11a2 2 0 0 1 2 2v7 M4 8h13 M8 4v4 M6 12h6 M6 16h5 M16.5 15.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z M19 21l2 2",
  reconocimientoSemantica:
    "M12 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6Z M5 15a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z M19 15a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5Z M10 9l-3.5 6 M14 9l3.5 6 M7.5 17.5h9",
  reconocimientoRecomendaciones:
    "M12 2l1.5 5.5L19 9l-5.5 1.5L12 16l-1.5-5.5L5 9l5.5-1.5L12 2Z M19 15l.8 2.2L22 18l-2.2.8L19 22l-.8-2.2L16 18l2.2-.8L19 15Z",
  reconocimientoValidacion:
    "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z M15 2v5h5 M8 14l2.5 2.5L16 11",
  reconocimientoCompletado: "M22 12a10 10 0 1 1-4-8 M22 4 11 15l-4-4",
  reconocimientoError:
    "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20Z M12 7v6 M12 17h.01",

  /**
   * Tema claro ↔ oscuro ↔ el que diga el sistema.
   *
   * El sol lleva núcleo y ocho rayos, la luna una sola silueta y el monitor
   * tres piezas. Morfear entre cantidades tan distintas es justo lo que hace
   * bien este motor —los trazos que sobran se recogen hacia el centro—, y de
   * ahí sale la sensación de que el sol se cierra sobre sí mismo para volverse
   * luna en vez de ser sustituido por otro dibujo.
   */
  sol: "M12 7a5 5 0 1 0 0 10 5 5 0 0 0 0-10Z M12 2v2 M12 20v2 M4.9 4.9l1.4 1.4 M17.7 17.7l1.4 1.4 M2 12h2 M20 12h2 M4.9 19.1l1.4-1.4 M17.7 6.3l1.4-1.4",
  luna: "M20.5 14.8A8.5 8.5 0 0 1 9.2 3.5a8.5 8.5 0 1 0 11.3 11.3Z",
  sistema:
    "M4 4h16a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1Z M12 16v4 M8 20h8",

  /** Índice de conversaciones del asistente. */
  conversaciones:
    "M8 9h8 M8 13h6 M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z",

  /** El PDF del presupuesto. */
  documentoPdf:
    "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z M15 2v5h5 M9 15h6 M9 11h2",
};
